export * from "./modal.service";

import Modal from "./modal.service";
import ModalSimples from "./ModalSimples.vue";

//export const HcModalSimples = ModalSimples;

export const ModalPlugin = {
  install
};

function install(Vue) {
  Modal.install(Vue);
}
